import { constant } from "../constant";

const initialState = {
  loading: false,
  durationLoading: false,
  result: {},
  errMsg: "",
  count: 0,
};

const PreAppointmentDataReducer = (state = initialState, action) => {
  switch (action.type) {
    // case "persist/REHYDRATE":
    //   // Reset loading states on page reload/rehydration
    //   return {
    //     ...state,
    //     loading: false,
    //     durationLoading: false,
    //     // result: {
    //     //   ...state.result,
    //     //   is_first_appointment: false,
    //     // },
    //   };
    case constant.GET_PRE_APPOINTMENT_DATA:
      return {
        ...state,
        loading: true,
      };
    case constant.GET_PRE_APPOINTMENT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.result,
        errMsg: "",
      };

    case constant.GET_PRE_APPOINTMENT_DATA_FAILED:
      return {
        ...state,
        loading: false,
        errMsg: action.errMsg,
      };
    case constant.CLEAN_PRE_APPOINTMENT_DATA:
      return {
        ...state,
        loading: false,
        result: {},
        count: 0,
        errMsg: "",
      };
    // // duration
    case constant.GET_PRE_APPOINTMENT_DATA_DURATION:
      return {
        ...state,
        durationLoading: true,
        loading: false,
        result: {
          ...state.result,
          appointment_duration: [],
        },
      };
    case constant.GET_PRE_APPOINTMENT_DATA_DURATION_SUCCESS:
      return {
        ...state,
        durationLoading: false,
        loading: false,
        result: {
          ...state.result,
          appointment_duration: [...action.result.appointment_duration],
          overview: {
            ...action.result.overview,
          },
        },
        errMsg: "",
      };
    case constant.GET_PRE_APPOINTMENT_DATA_DURATION_FAILED:
      return {
        ...state,
        durationLoading: false,
        loading: false,
        errMsg: action.errMsg,
      };
    case constant.CLEAN_PRE_APPOINTMENT_DATA_DURATION:
      return {
        ...state,
        durationLoading: false,
        errMsg: "",
      };
    default:
      return state;
  }
};

export default PreAppointmentDataReducer;
